module.exports = __webpack_public_path__ + "img/icon_repair.cb6ddd73.png";